<template>
  <div class="hechengpoolgood-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入材料名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.goodname"
                 clearable
                 placeholder="输入商品名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable(1)">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Card style="width:100%">
        <Row style="border-bottom:1px solid #F3F4F5;height:40px;line-height:40px">
          <Col :xs="7"
               :sm="7">选择材料</Col>
          <Col :xs="7"
               :sm="7">数量</Col>
          <Col :xs="7"
               :sm="7">封面图</Col>
        </Row>
        <Row style="height:120px;margin-top:10px"
             v-for="(item,index) in ruleList">
          <Col :xs="8"
               :sm="8"
               style="padding-right:20px">
          <Select v-model="item.data_id"
                  clearable
                  filterable
                  placeholder="选择材料">
            <Option v-for="item in datatablelist"
                    :value="item.id"
                    :key="item.name">{{item.name}}</Option>
          </Select>
          </Col>
          <Col :xs="8"
               :sm="8"
               style="padding-right:20px">
          <Input v-model="item.num"
                 placeholder="请输入数量" />
          </Col>
          <Col :xs="8"
               :sm="8"
               style="padding-right:20px">
          <upload-thumb v-model="item.thumb"
                        :ref="'uploadthumb'+index"
                        :defaultList="item.thumblist"
                        :autoCropWidth="320"
                        :autoCropHeight="320"
                        :defaultTip="'建议图片尺寸:320*320,大小不超过2M'"></upload-thumb>
          </Col>
          <!-- <Col :xs="3" :sm="3">
            <Icon type="md-trash" size="30" style="margin-top:5px" @click="deleteData(index)" />
          </Col>-->
        </Row>
        <div class="action_back">
          <Button type="success"
                  @click="saveRule">保存</Button>
          <!-- <Button type="info" style="margin-right:20px" @click="addGoodRule">添加</Button> -->
        </div>
      </Card>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../../common/thumb";

export default {
  name: "hechengpoolgood-list",
  data () {
    return {
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      ruleList: [],
      datatablelist: [],
      tablelist: [],
      rule: {
        id: null,
        dataList: [],
        goodsList: []
      },
      loading: true,
      dataloading: true,
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: "",
      formItem: {},
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "材料",
          key: "dataStr",
          minWidth: 200
        },
        {
          title: "商品",
          key: "goodsStr",
          minWidth: 200
        },
        {
          title: "状态",
          key: "status",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  props: {
                    value: !params.row.status // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": value => {
                      this.changeStatus(params.row.id, value);
                    }
                  }
                },
                "开关"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 300,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showProbabilityList(params.row.id);
                    }
                  }
                },
                "抽奖规则"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showGoodList(params.row.id);
                    }
                  }
                },
                "商品管理"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.deleteRule(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      showModalStatus: false
    };
  },
  created: function () {
    this.getTableList();
    this.getDataList();
  },
  components: {
    UploadThumb
  },

  methods: {
    // 去抽奖规则
    showProbabilityList (id) {
      this.$router.push("/hechengpoolprobability/list/" + id);
    },
    showGoodList (id) {
      this.$router.push("/hechengpoolgood/list/" + id);
    },
    getTableList: function () {
      this.renderTable(1);
      return;
    },
    //获取材料
    getDataList: function () {
      this.$api.data
        .list({
          page: 1,
          size: 20
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.datatablelist = res.result.list;
          }
        });
      return;
    },
    // addGoodRule() {
    //   this.ruleList.push({
    //     data_id: null,
    //     num: null,
    //     thumb: "",
    //     thumblist:[]
    //   });
    // },
    // 详情
    detail (id) {
      this.title = "编辑规则";
      this.showModalStatus = true;
      var params = {
        hecheng_rule_id: id
      };
      this.hecheng_rule_id = id;
      this.$api.hechengpooldata.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          var list = res.result;
          for (let i = 0; i < list.length; i++) {
            const rule = list[i];
            rule.thumblist = [];
            if (rule.thumb) {
              rule.thumblist.push({
                name: rule.thumb,
                url: rule.thumb,
                status: "finished"
              });
            }
          }
          this.ruleList = list;
        }
      });
    },
    deleteData (index) {
      var that = this;
      var rule = that.ruleList[index];
      if (rule.id == null || rule.id == undefined || rule.id == "") {
        that.realDeleteData(index);
        return;
      }
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          that.realDeleteData(index);
        }
      });
    },
    realDeleteData (index) {
      var that = this;
      var rule = that.ruleList[index];
      if (rule.id && rule.id != undefined && rule.id != "") {
        var params = {
          id: rule.id
        };
        that.$api.hechengpooldata.remove(params).then(res => {
          that.dataloading = false;
          if (res.code == 200) {
            that.$Message.success(res.msg);
            that.ruleList.splice(index, 1);
          } else {
            that.$Message.error(res.msg);
          }
        });
      } else {
        that.ruleList.splice(index, 1);
        that.$Message.success("删除成功");
      }
    },
    saveRule () {
      var that = this;
      var ruleList = this.ruleList;
      for (let i = 0; i < ruleList.length; i++) {
        const rule = ruleList[i];
        rule.thumb = null;
        if (this.$refs["uploadthumb" + i]) {
          if (
            this.$refs["uploadthumb" + i].length &&
            this.$refs["uploadthumb" + i].length > 0
          ) {
            var uploadthumb = this.$refs["uploadthumb" + i][0];
            if (uploadthumb.uploadList && uploadthumb.uploadList.length > 0) {
              rule.thumb = uploadthumb.uploadList[0].url;
            }
          }
        }
      }
      var params = {
        attrs: ruleList
      };
      if (
        this.hecheng_rule_id == "" ||
        this.hecheng_rule_id == 0 ||
        this.hecheng_rule_id == undefined
      ) {
        this.$api.hechengpooldata.create(params).then(res => {
          that.dataloading = false;
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.showModalStatus = false;
            this.getTableList();
          } else {
            this.$Message.error(res.msg);
          }
        });
      } else {
        params.hecheng_rule_id = this.hecheng_rule_id;
        this.$api.hechengpooldata.edit(params).then(res => {
          that.dataloading = false;
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.showModalStatus = false;
            this.getTableList();
          } else {
            this.$Message.error(res.msg);
          }
        });
      }
    },
    // 展开添加
    showModel () {
      this.title = "添加规则";
      this.rule = {
        thumb: "",
        data_id: "0"
      };
      this.hecheng_rule_id = "";
      this.ruleList = [];
      for (let i = 0; i < this.datatablelist.length; i++) {
        const item = this.datatablelist[i];
        var rule = {
          data_id: item.id,
          num: 0,
          thumb: item.thumb,
          thumblist: [
            {
              name: item.thumb,
              url: item.thumb,
              status: "finished"
            }
          ]
        };
        this.ruleList.push(rule);
      }
      this.isable = true;
      this.thumblist = new Array();
      this.getDataList();
      this.showModalStatus = !this.showModalStatus;
    },

    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable();
    },
    // 筛选
    renderTable: function (name) {
      if (name == 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        goodname: this.formItem.goodname,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.hechengpooldata.hechengrulelist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          for (let i = 0; i < this.tablelist.length; i++) {
            const rule = this.tablelist[i];
            var dataStr = "";
            for (let j = 0; j < rule.dataList.length; j++) {
              const cailiao = rule.dataList[j];
              dataStr += cailiao.title + "[" + cailiao.num + "]";
              if (j != rule.dataList.length - 1) {
                dataStr += "、";
              }
            }
            rule.dataStr = dataStr;
            var goodsStr = "";
            if (rule.goodsList) {
              for (let j = 0; j < rule.goodsList.length; j++) {
                const goods = rule.goodsList[j];
                goodsStr += goods.title;
                if (j != rule.goodsList.length - 1) {
                  goodsStr += "、";
                }
              }
            }

            rule.goodsStr = goodsStr;
          }
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.hechengpooldata
        .statusrule({ id: index, status: value })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
          }
        });
    },
    deleteRule (index) {
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.hechengpooldata.removerule({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList(1);
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
.action_back {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  margin-top: 20px;
}
</style>

